module.exports = __webpack_public_path__ + "static/media/PlayStore-button.785085a0.png";